export const getImageAsBlob = (imageUrl) => {
    const filename = 'mada_share.jpg';
    const targetPath = cordova.file.documentsDirectory + filename;
    const fileTransfer = new FileTransfer();

    return new Promise((resolve, reject) => {
        fileTransfer.download(
            imageUrl,
            targetPath,
            (entry) => {
                const mywallpaper = entry.toURL();
                window.resolveLocalFileSystemURL(mywallpaper, (fileEntry) => {
                    fileEntry.file((file) => {
                        const reader = new FileReader();
                        let data = null;

                        reader.onloadend = () => {
                            data = reader.result;
                            resolve(data);
                        };
                        reader.readAsDataURL(file);
                    });
                });
            }, 
            (error) => {
                reject(error);
            },
            false,
        );
    });
}

export const delay = (promise, time) => {
    return Promise.all([promise, new Promise(resolve => {
        setTimeout(() => resolve(), time);
    })]).then(responses => responses[0]);
}
